/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const CheckGreen: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="check-green" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1182.0525 996.115L536.6899999999999 307.7000000000001L177.9474999999999 666.4425000000002L236.0449999999999 724.5400000000002L534.7774999999999 425.8075000000003L1122.085 1052.3000000000002L1182.0525 996.1150000000002z" : "M945.642 796.892L429.3519999999999 246.1600000000001L142.3579999999999 533.1540000000001L188.8359999999999 579.6320000000002L427.822 340.6460000000002L897.668 841.8400000000001L945.642 796.8920000000003z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
CheckGreen.displayName = `Blueprint5.Icon.CheckGreen`;
export default CheckGreen;
